const custom_profile_fields = {
    table: {
        add_button: '新增個人資料欄位',
        title: {
            field_label: '欄位標籤',
            type: '類型',
            user_data_key: '使用者資料鍵值',
        },
        placeholder: {
            title: '收集使用者資料',
            description: '自訂欄位以在註冊時收集更多使用者資料。',
        },
    },
    type: {
        Text: '文字',
        Number: '數字',
        Date: '日期',
        Checkbox: '勾選框 (布林值)',
        Select: '下拉選單 (單選)',
        Url: '網址',
        Regex: '正規表示式',
        Address: '地址 (組合)',
        Fullname: '全名 (組合)',
    },
    modal: {
        title: '新增個人資料欄位',
        subtitle: '自訂欄位以在註冊時收集更多使用者資料。',
        built_in_properties: '基礎使用者資料',
        custom_properties: '自訂使用者資料',
        custom_data_field_name: '使用者資料鍵值',
        custom_data_field_input_placeholder: '輸入使用者資料鍵值，例如 `myFavoriteFieldName`',
        custom_field: {
            title: '自訂資料',
            description: '任何額外的使用者屬性，可定義以滿足應用程式的獨特需求。',
        },
        type_required: '請選擇屬性類型',
        create_button: '建立個人資料欄位',
        avatar: {
            description: '讓使用者在註冊時上傳大頭貼，上傳後的圖片 URL 將儲存為使用者 avatar。',
            storage_not_configured: 'Avatar 上傳需要先設定儲存服務，請先設定 storage 後再新增此欄位。',
        },
    },
    details: {
        page_title: '個人資料欄位詳情',
        back_to_sie: '返回登入體驗',
        enter_field_name: '輸入個人資料欄位名稱',
        delete_description: '此操作無法撤銷。確定要刪除此個人資料欄位嗎？',
        field_deleted: '個人資料欄位 {{name}} 已成功刪除。',
        key: '使用者資料鍵值',
        field_name: '欄位名稱',
        field_type: '欄位類型',
        settings: '設定',
        settings_description: '自訂欄位以在註冊時收集更多使用者資料。',
        address_format: '地址格式',
        single_line_address: '單行地址',
        multi_line_address: '多行地址 (例如：街道、城市、州、郵遞區號、國家)',
        components: '組件',
        components_tip: '選擇組成複雜欄位的組件。',
        label: '欄位標籤',
        label_placeholder: '標籤',
        label_tip: '需要本地化嗎？在<a>登入體驗 > 內容</a>中新增語言',
        label_tooltip: '浮動標籤，用於指示欄位用途。最初顯示在輸入框內，聚焦或有值後會移到輸入框上方。',
        placeholder: '欄位佔位符',
        placeholder_placeholder: '佔位符',
        placeholder_tooltip: '輸入框內的範例或格式提示。通常在標籤浮起後顯示，應保持精簡（例如：MM/DD/YYYY）。',
        description: '欄位說明',
        description_placeholder: '說明',
        description_tooltip: '顯示在文字欄位下方的輔助說明文字。用於較長的操作指引或無障礙提示。',
        options: '選項',
        options_tip: '每行輸入一個選項。使用 value:label 格式（例如 red:紅色）。也可以只寫 value；若未提供 label，顯示時會回退為該 value。',
        options_placeholder: 'value1:label1\nvalue2:label2\nvalue3:label3',
        regex: '正規表示式',
        regex_tip: '定義正規表示式以驗證輸入。',
        regex_placeholder: '^[a-zA-Z0-9]+$',
        date_format: '日期格式',
        date_format_us: 'MM/dd/yyyy (例如：美國)',
        date_format_uk: 'dd/MM/yyyy (例如：英國和歐洲)',
        date_format_iso: 'yyyy-MM-dd (國際標準)',
        custom_date_format: '自訂日期格式',
        custom_date_format_placeholder: '輸入自訂日期格式。例如 "MM-dd-yyyy"',
        custom_date_format_tip: '查看<a>date-fns</a>文件以獲取有效的格式標記。',
        input_length: '輸入長度',
        value_range: '數值範圍',
        min: '最小值',
        max: '最大值',
        default_value: '預設值',
        checkbox_checked: '已選取 (True)',
        checkbox_unchecked: '未選取 (False)',
        required: '必填',
        required_description: '啟用時，使用者必須填寫此欄位。停用時，此欄位為選填。',
        avatar_upload_description: '終端使用者在註冊時上傳大頭貼，儲存的值為上傳後的圖片 URL。',
    },
};
export default Object.freeze(custom_profile_fields);
